import { mergeAttributes } from '@tiptap/core';
import { HeadingNode } from './heading-node';

export const HeadingAsParagraphNode = HeadingNode.extend({
  renderHTML({ HTMLAttributes }) {
    return ['p', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
});
